import { useEffect, useRef } from "react";
import { Overline, Reveal } from "@/lib/reveal";

function PsychologyTodaySeal() {
  const anchorRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    const url = atob(
      "aHR0cHM6Ly93d3cucHN5Y2hvbG9neXRvZGF5LmNvbS9hcGkvdmVyaWZpZWQtc2VhbC9zZWFscy8xNC9wcm9maWxlLzE3ODMzMjM/Y2FsbGJhY2s9c3hjYWxsYmFjaw==",
    )
      .replace("[BADGE]", "14")
      .replace("[PROFILE_ID]", "1783323");
    const w = window as unknown as { sxcallback?: (e: { name: string; image: { content: string; dimensions: { width: string; height: string } } }) => void };
    w.sxcallback = (e) => {
      const a = anchorRef.current;
      if (!a) return;
      a.style.display = "inline-block";
      a.style.backgroundRepeat = "no-repeat";
      a.style.backgroundImage = `url("data:image/svg+xml;base64,${e.image.content}")`;
      a.style.width = `${parseInt(e.image.dimensions.width)}px`;
      a.style.height = `${parseInt(e.image.dimensions.height)}px`;
      a.title = e.name;
    };
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.src = url;
    document.body.appendChild(s);
    return () => {
      delete w.sxcallback;
    };
  }, []);

  return (
    <div data-testid="psychology-today-badge" className="mt-8">
      {/* Professional verification provided by Psychology Today */}
      <a
        ref={anchorRef}
        href="https://www.psychologytoday.com/profile/1783323"
        className="sx-verified-seal"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="April Cook Suravallop verified by Psychology Today (opens profile in a new tab)"
      />
    </div>
  );
}

export function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      aria-labelledby="about-heading"
      className="relative bg-charcoal py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <Reveal>
          <Overline index="02" label="About April" />
        </Reveal>

        <div className="mt-12 grid gap-16 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <h2
              id="about-heading"
              className="font-serif text-3xl font-light leading-tight tracking-tight text-ivory sm:text-5xl"
            >
              April Cook Suravallop
              <span className="mt-3 block font-mono text-sm tracking-[0.25em] text-gold">
                LMFT #163626
              </span>
            </h2>
            <PsychologyTodaySeal />
          </Reveal>

          <div className="lg:col-span-7 lg:col-start-6">
            <Reveal delay={0.1}>
              <blockquote className="border-l border-gold/50 pl-8 font-serif text-2xl font-light italic leading-snug text-ivory sm:text-4xl">
                “You are your best thing.”
                <span className="mt-4 block font-mono text-xs not-italic tracking-[0.3em] uppercase text-stone/60">
                  Toni Morrison
                </span>
              </blockquote>
            </Reveal>
            <Reveal delay={0.18}>
              <div className="mt-12 max-w-xl space-y-8 text-base leading-loose text-stone/85">
                <p>
                  I am a licensed Marriage and Family Therapist based in
                  Berkeley, working with people throughout California. My
                  clinical background has taken me into schools, community
                  mental health, hospitals, work with families, and spaces where
                  people were navigating profound change.
                </p>
                <p>
                  I am interested in the whole person—not only symptoms, but
                  relationships, history, culture, memory, family, humor,
                  contradiction, and the ways we learn to survive what has
                  happened to us.
                </p>
                <p>
                  My work is thoughtful, direct, collaborative, and deeply
                  curious. I will listen carefully, but I will also ask
                  questions, notice patterns, and invite you to look at things
                  from another angle. You remain the expert in your own life. My
                  role is to help you hear yourself more clearly.
                </p>
                <p className="text-ivory">
                  Therapy centered on you—your story, your relationships, and
                  the deeper work of healing.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
